import React from 'react'
import Input from '../Input'
import { useFormState } from 'react-final-form'

const InputField = ({ input, meta, ...rest }) => {
  const { submitFailed } = useFormState({ subscription: { submitFailed: true } })
  return (
    <Input
      {...(meta.error && submitFailed && { error: meta.error })}
      {...input}
      {...rest}
    />
  )
}

export default InputField
